let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("KvRHa")).then(() => parcelRequire('gjJ2S'));